import setupCompanyAccount from "./setupCompanyAccount";

export default [setupCompanyAccount];
